import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('sales-flat-rates', { params, ...config }),
  businesses: (params = {}, config = {}) => axios.get('sales-flat-rates/businesses', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('sales-flat-rates/metrics', { params, ...config }),
  show: (saleId, params = {}, config = {}) => axios.get(`sales-flat-rates/${saleId}`, { params, ...config }),
  update: (saleId, data = {}, config = {}) => axios.put(`sales-flat-rates/${saleId}`, data, config),
  updateStatus: (saleId, data = {}, config = {}) => axios.put(`sales-flat-rates/${saleId}/status`, data, config),
  delete: (saleId, config = {}) => axios.delete(`sales-flat-rates/${saleId}`, config),
};
